var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaskgroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 59,
    viewBox: "0 0 326 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_390_3260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 326,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 326,
    height: 60,
    fill: "#D11116"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_390_3260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1285 64.9773L34.3516 56.1864L19.1285 47.3955V64.9773Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8096 56.1871L88.6143 59.5442V52.8301L82.8096 56.1871Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.437 57.0124L118.889 56.1873L117.437 55.3623V57.0124Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2666 29.1312L42.5752 33.9392V24.3232L34.2666 29.1312Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4926 31.8332L74.1875 29.1305L69.4926 26.4277V31.8332Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9986 4.15363L26.6123 2.07683L22.9986 0V4.15363Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.099 64.9773L270.322 56.1864L255.099 47.3955V64.9773Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78 56.1871L324.585 59.5442V52.8301L318.78 56.1871Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.934 56.1877L233.93 64.8364V47.5391L218.934 56.1877Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.237 29.1312L278.546 33.9392V24.3232L270.237 29.1312Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.463 31.8332L310.158 29.1305L305.463 26.4277V31.8332Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.568 33.8526L218.763 29.13L210.568 24.3789V33.8526Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.503 2.07683L230.146 4.15363V0L226.503 2.07683Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.969 4.15363L262.583 2.07683L258.969 0V4.15363Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.042 58.604L169.253 56.1858L165.042 53.7676V58.604Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.468 29.1323L183.366 31.3513V26.8848L179.468 29.1323Z",
    fill: "#D11116"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskgroup);
export default __webpack_public_path__ + "static/media/Mask group.ef20e9da61d6233c23dceba699d43a57.svg";
export { ForwardRef as ReactComponent };